import ApiService from '../../utils/api.service'
import { API_VERSION } from '../../utils/config'
import { BOOK, PREVIEW, SIMULATE, VALIDATE_VALUES } from '../actions/productTree'

const endpoint = `api/${API_VERSION}/product-tree`

const actions = {
  [PREVIEW]: async (_, { composition, added, productFamily, productName }) => {
    const { data } = await ApiService.post(`${endpoint}/compositions/preview`, { composition, added, product_family: productFamily, product_name: productName || undefined })
    return data
  },

  [VALIDATE_VALUES]: async (_, { composition, productFamily, productName, formValues, metadata, cancelToken }) => {
    const { data } = await ApiService.post(
      `${endpoint}/compositions/validate-values`,
      { composition, product_family: productFamily, product_name: productName, form_values: formValues, metadata },
      { cancelToken }
    )
    return data
  },

  [BOOK]: async (_, { composition, productFamily, productName, formValues, metadata }) => {
    const { data } = await ApiService.post(`${endpoint}/`, { composition, product_family: productFamily, product_name: productName, form_values: formValues, metadata })
    return data
  },

  [SIMULATE]: async (_, { composition, formValues, levels }) => {
    const { data } = await ApiService.post(`${endpoint}/compositions/simulate`, { composition, form_values: formValues, levels })
    return data
  },
}

export default {
  state: {},
  getters: {},
  actions,
  mutations: {},
}
